import { FC } from 'react';
import { useSelector } from 'react-redux';
import { CaretRightOutlined, LoadingOutlined, PauseOutlined } from '@ant-design/icons';
import type { RootState } from 'store';
import useTaskStartStop from './useTaskStartStop';

interface TaskInlineTimerButtonProps {
  taskId: string;
  taskStatus?: string;
  relatedUsers?: any[];
  inTable?: boolean;
  fontSize?: number;
  color?: string;
}

const TaskInlineTimerButton: FC<TaskInlineTimerButtonProps> = ({ taskId, relatedUsers, inTable, fontSize = 14, color }) => {
  const currentUser = useSelector((store: RootState) => store.auth.user);
  const { isRunning, saving, toggle } = useTaskStartStop(taskId);

  if (relatedUsers && !relatedUsers.some((u) => u.pivot?.type === 'responsible' && u.uuid === currentUser?.uuid)) {
    return null;
  }

  let icon: React.ReactNode;
  let iconColor: string | undefined;
  let iconFontWeight: number | undefined;

  if (saving) {
    icon = <LoadingOutlined />;
    iconColor = color ?? (inTable ? '#0044cc' : undefined);
  } else if (isRunning) {
    icon = <PauseOutlined className="task-inline-timer-button-icon"  />;
    iconColor = '#FFBB3F';
    iconFontWeight = 700;
  } else {
    icon = <CaretRightOutlined className="task-inline-timer-button-icon" />;
    iconColor = '#43D62D';
  }

  return (
    <div className="ant-table-button" style={{ display: 'flex', alignItems: 'center' }}>
      <span
        onClick={saving ? undefined : toggle}
        style={{
          fontSize: isRunning ? fontSize + 2 : fontSize,
          fontWeight: iconFontWeight,
          cursor: saving ? 'default' : 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          lineHeight: 1,
          color: iconColor,
        }}
      >
        {icon}
      </span>
    </div>
  );
};

export default TaskInlineTimerButton;
